import useSWR from "swr"
import {API_TEAMS} from "../constants/apiUrls"

export default function useCountTeamTasks(teamId) {
    const {data, mutate, error} = useSWR(`${API_TEAMS}/${teamId}/history/count`)
    return {
        countTeamTasks: data,
        mutateCountTeamTasks: mutate,
        isLoadingCountTeamTasks: !error && !data,
        isErrorCountTeamTasks: error
    }
}